import { render, staticRenderFns } from "./VCheckMatrix.vue?vue&type=template&id=5958ded8&scoped=true"
import script from "./VCheckMatrix.vue?vue&type=script&lang=js"
export * from "./VCheckMatrix.vue?vue&type=script&lang=js"
import style0 from "./VCheckMatrix.vue?vue&type=style&index=0&id=5958ded8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5958ded8",
  null
  
)

export default component.exports